import React, { useEffect, useState } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container, Form } from 'react-bootstrap';
import CustomHeader from '../Components/CustomHeader/CustomHeader';
import CustomTable from '../Components/CustomTable/CustomTable';
import { activeMainMeal, fetchTrainersMainMeals } from '../hooks/MainMeals';
import { useDispatch, useSelector } from 'react-redux';
import { fetchweeks } from '../hooks/week';
import { useNavigate } from 'react-router-dom';
import { addOrder, fetchOrders } from '../hooks/order';

function AddNewRequest() {
    const studentsData = [
    { id: 1, name: 'السبت', breakfast: true, lunch: true, dinner: true },
    { id: 2, name: 'الاحد', breakfast: true, lunch: true, dinner: true },
    { id: 3, name: 'الاتنين', breakfast: false, lunch: true, dinner: true },
    { id: 4, name: 'الثلاثاء', breakfast: false, lunch: true, dinner: true },
    { id: 5, name: 'الاربعاء', breakfast: true, lunch: true, dinner: true },
    { id: 6, name: 'الخميس', breakfast: true, lunch: true, dinner: true },
  ];
  const initialData = [
  { id: 1, key: "sat", name: "السبت", meals: {} },
  { id: 2, key: "sun", name: "الاحد", meals: {} },
  { id: 3, key: "mon", name: "الاتنين", meals: {} },
  { id: 4, key: "tue", name: "الثلاثاء", meals: {} },
  { id: 5, key: "wed", name: "الاربعاء", meals: {} },
  { id: 6, key: "thu", name: "الخميس", meals: {} },
  { id: 7, key: "fri", name: "الجمعة", meals: {} },
];
  const dispatch = useDispatch();
  const navigate=useNavigate()
  const { list: MainMealsList } = useSelector((state) => state.mainMeals);
  const { list: weekList } = useSelector((state) => state.week);
  const [tableData, setTableData] = useState(initialData);
    const { list: orders } = useSelector((state) => state.order);


const today = new Date();

const currentWeek = weekList.find(week => {
  const start = new Date(week.start_date);
  const end = new Date(week.end_date);

  return today >= start && today <= end;
});

console.log(currentWeek,"currentWeek");
  useEffect(() => {
    dispatch(fetchTrainersMainMeals())
        dispatch(fetchOrders(currentWeek?.id))
  
    dispatch(fetchweeks())
  }, [])
  useEffect(() => {
  if (orders?.days && MainMealsList.length > 0) {
    const updated = initialData.map((day) => {
      const selectedMeals = orders.days[day.key] || [];

      const mealsObj = {};

      selectedMeals.forEach((mealId) => {
        mealsObj[mealId] = true;
      });

      return {
        ...day,
        meals: mealsObj
      };
    });

    setTableData(updated);
  }
}, [orders, MainMealsList]);
const handleChange = (dayId, mealId) => {
  setTableData(prev =>
    prev.map(day =>
      day.id === dayId
        ? {
            ...day,
            meals: {
              ...day.meals,
              [mealId]: !day.meals?.[mealId]
            }
          }
        : day
    )
  );
};
const handleSubmit = (e) => {
  e.preventDefault();

  const result = {
    days: {}
  };

  tableData.forEach(day => {
    result.days[day.key] = Object.entries(day.meals || {})
      .filter(([mealId, value]) => value === true) // ناخد بس اللي checked
      .map(([mealId]) => Number(mealId)); // نحول لـ number
  });

  const data={
    week_id:currentWeek?.id,
    data:result
  }
  
      dispatch(addOrder(data))
        .unwrap() // Allows us to use .then() / .catch() on the thunk result
        .then(() => {
          alert("تم إضافة الطلب بنجاح");
          navigate('/dashboard/student-meals'); // Redirect to list page
        })
        .catch((err) => {
          // Error is already handled in Redux, but you can do specific UI logic here
          console.error("Failed to save:", err);
        });
  
};

  const header = [
    "اليوم",
    ...MainMealsList.filter((item) => item.parent_id==null).map((item) => item.name),

    ""


  ]

const body = (
  <tbody>
    {tableData.map((day) => (
      <tr key={day.id}>
        <td>{day.name}</td>

        {MainMealsList.filter((item) => item.parent_id==null).map((meal) => {
          console.log(meal);
          
          return(
          <td key={meal.id}>
            <Form.Check
              id={`day-${day.id}-meal-${meal.id}`} // مهم جدًا
                  className='w-50'
              // checked={day.meals?.[meal.id] || false}
              checked={day.meals?.[meal.id] || false}
              onChange={() => handleChange(day.id, meal.id)}
              label={day.meals?.[meal.id] ? "أريد" : "لا أريد"}
            />
          </td>
        )})}
      </tr>
    ))}
  </tbody>
);
  const data = [
    { id: 1, date: "2026-04-01" },
    { id: 2, date: "2026-04-03" },
    { id: 3, date: "2026-04-08" },
    { id: 4, date: "2026-04-10" },
    { id: 5, date: "2026-04-15" },
  ];

  const fiteration = [
    { id: 0, title: "الوجبات", options: [{ id: "01", title: "الافطار" }, { id: "02", title: "الغداء" }, { id: "03", title: "العشاء" }] },
  ]




  return (
    <div>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"قائمة الطعام"}
          subtitle={""}
          downloadData={false}
          addData={false}
          status={"meal"}


        />

        <CustomTable
          data={studentsData}
          currentData={''}
          allData={''}
          header={header}
          status={"new-meal"}
          body={body}
          handleSubmit={handleSubmit}

        />
        {/* <CustomPagination
          currentData={1}
          allData={25}
          datainPage={5}

        /> */}
      </Container>
    </div>
  )
}

export default AddNewRequest
